document.addEventListener('DOMContentLoaded', function () {
  // Smooth scroll ONLY for in-page anchors inside copy block
  const links = document.querySelectorAll('.copy-block__body-text a');
  links.forEach(link => {
    link.addEventListener('click', function (e) {
      const rawHref = this.getAttribute('href') || '';

      // Only handle pure hash links like "#section"
      if (!rawHref.startsWith('#')) return; // let normal links work

      const id = decodeURIComponent(rawHref.slice(1));
      if (!id) return;

      // Prefer ID; also try named anchors as a fallback
      const cssEscape = (window.CSS && CSS.escape) ? CSS.escape : s => s.replace(/["\\]/g, '\\$&');
      const target =
        document.getElementById(id) ||
        document.querySelector(`[name="${cssEscape(id)}"]`);

      if (!target) return;

      e.preventDefault(); // only stop default when we actually scroll

      const headerOffset = 50; // your fixed-header offset
      const y = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;

      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  });

  // Remove target attribute from sitemap links to prevent opening in new tab
  document.querySelectorAll('.sitemap-lev2 a[target]').forEach(link => {
    link.removeAttribute('target');
  });
});
